import { render, staticRenderFns } from "./TreeStorage.vue?vue&type=template&id=0f190782&scoped=true&"
import script from "./TreeStorage.vue?vue&type=script&lang=ts&"
export * from "./TreeStorage.vue?vue&type=script&lang=ts&"
import style0 from "./TreeStorage.vue?vue&type=style&index=0&id=0f190782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f190782",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
